import React, { useState, useEffect } from "react";
import CustomDatePicker from "../../../../components/Custom-Datepicker";
import { Table } from "react-bootstrap";
import Select from "react-select";
import { FaSpinner } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { toast } from "react-toastify";
import * as Yup from "yup";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";

const PayrollScalesAdd = () => {
  const initialFormData = {
    Code: "",
    Name: "",
    Description: "",
    Slabs: [
      {
        Sequence: 1,
        PayrollID: "",
        FromDate: "",
        ToDate: "",
      },
    ],
  };
  const navigate = useNavigate();
  const [formData, setFormData] = useState(initialFormData);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
console.log("errors",errors);

  const [payrollOption, setPayrollOption] = useState([]);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Add Payroll Scales"));
  }, []);

  useEffect(() => {
    fetchPayrollScalesList();
  }, []);

  const fetchPayrollScalesList = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}payrolls/scales`);
      if (response.status === 200) {
        const cleanedData = response?.data?.data;
        const payOPt = response?.data?.payroll?.map((ele, index) => ({
          value: ele?.value,
          label: ele?.text,
        }));
        setPayrollOption(payOPt);
        setLoading(false);
      } else {
        console.error(
          "Failed to fetch partner Master. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Partner Master:", error);
    }
  };

  const handleAddLine = () => {
    const currentRow =
      formData.Slabs.length !== 0
        ? formData.Slabs[formData.Slabs.length - 1]
        : null;

    if (
      currentRow &&
      (currentRow.PayrollID === null || currentRow.PayrollID === "")
    ) {
      toast.error("Please fill in the current row.", {
        position: "top-right",
      });
      return;
    }

    // Generate a new LineNo and maintain a sequential sequence number
    let newLineNo = 1;
    let SeqNo = 1;
    const existingLineNos = formData.Slabs.map((row) => row.LineNo);

    while (existingLineNos.includes(newLineNo)) {
      newLineNo++;
      SeqNo++;
    }

    const updatedSlabs = [
      ...formData.Slabs,
      {
        LineNo: newLineNo,
        Sequence: SeqNo,
        PayrollID: "",
        FromDate: "",
        ToDate: "",
      },
    ];

    // Reassign sequence numbers sequentially
    const reassignedSlabs = updatedSlabs.map((slab, index) => ({
      ...slab,
      Sequence: index + 1,
    }));

    setFormData((prevState) => ({
      ...prevState,
      Slabs: reassignedSlabs,
    }));
  };

  const handleDeleteSlabsLine = (lineNo) => {
    setFormData((prevState) => ({
      ...prevState,
      Slabs: prevState.Slabs.filter((slab) => slab.LineNo !== lineNo),
    }));
  };

  const schema = Yup.object().shape({
    Code: Yup.string().required("Code is required"),
    Name: Yup.string().required("Name is required"),
    Slabs: Yup.array()
      .of(
        Yup.object().shape({
          PayrollID: Yup.string()
            .required("PayrollID is required")
            .test(
              "gross-or-net-payrollid",
              "Invalid PayrollID for the Type provided",
              function (value, context) {
                const { Type } = context.parent;
                if (Type === "Gross" && value !== "9") return false;
                if (Type === "Net" && value !== "15") return false;
                return true;
              }
            ),
        })
      )
      .test(
        "at-least-one-gross-and-net",
        "Please include payrolls of type Gross Payable and Net Payable!",
        function (slabs) {
          if (!slabs || slabs.length === 0) return false;

          const hasGross = slabs.some(
            (slab) => slab.Type === "Gross" && slab.PayrollID === "9"
          );
          const hasNet = slabs.some(
            (slab) => slab.Type === "Net" && slab.PayrollID === "15"
          );

          return hasGross && hasNet;
        }
      ),
  });


  const validateField = async (fieldName, value) => {
    try {
      const fieldData = { [fieldName]: value };
      const fieldSchema = Yup.object().shape({
        [fieldName]: schema.fields[fieldName],
      });

      await fieldSchema.validate(fieldData, { abortEarly: false });

      // Clear the error for the specific field
      setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: "" }));
    } catch (err) {
      if (err.path === fieldName) {
        // Update the error only for the specific field
        setErrors((prevErrors) => ({
          ...prevErrors,
          [fieldName]: err.message,
        }));

        if (fieldName.startsWith("Slabs")) {
          toast.error(err.message, { position: "top-right" });
        }
      } else {
        console.error("Unexpected validation structure:", err);
      }
    }
  };
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevState) => ({ ...prevState, [name]: value }));

    // Validate this field on change
    validateField(name, value);
  };

  const handleSlabsChange = async (e, index) => {
    const { name, type, checked, value } = e.target;
    const updatedSlabs = [...formData.Slabs];
    const newValue = type === "checkbox" ? checked : value;

    updatedSlabs[index] = {
      ...updatedSlabs[index],
      [name]: newValue,
    };

    setFormData((prevState) => ({
      ...prevState,
      Slabs: updatedSlabs,
    }));

    // Trigger validation on `Slabs` after form change
    await validateField("Slabs", updatedSlabs);
  };

  const handleSlabsSelect = (selectedOption, name, index) => {
    const value = selectedOption.value;

    setFormData((prevData) => {
      const updatedSlabs = prevData.Slabs.map((slab, i) => {
        if (i === index) {
          return {
            ...slab,
            [name]: value, // Update the specific field in the correct slab
          };
        }
        return slab; // Leave other slabs unchanged
      });

      const updatedData = { ...prevData, Slabs: updatedSlabs };

      // Trigger validation for the specific field after updating
      validateField(`${name}[${index}]`, value);

      return updatedData;
    });
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    await schema.validate(formData, { abortEarly: false });
    setErrors({});

    const response = await PostServiceCaller(
      `${API_URL}payrolls/scales`,
      formData,
      "post"
    );

    if (response.status === 200) {
      toast.success("Data submitted successfully");
    }
  } catch (error) {
    if (error.name === "ValidationError") {
      const validationErrors = {};
      error.inner.forEach((err) => {
        validationErrors[err.path] = err.message;
        
        // Show toast for Slabs error immediately
        if (err.path === 'Slabs') {
          toast.error(err.message, { position: "top-right" });
        }
      });
      setErrors(validationErrors);
    } else {
      console.error("Unexpected Error:", error);
    }
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="container-fluid" id="skill_section">
      <div className="container-fluid" id="skill-table-area">
        <form onSubmit={handleSubmit}>
          <div className="row ">
            <div className="col-md-12 flex-col mt-1">
              <div class="card">
                <div class="card-header">
                  <h5 className="subheading">Payroll Details</h5>
                </div>
                <div className="card-body">
                  <div class="row">
                    <div className="col-md-4">
                      <label className="form-label">
                        Code <span className="required">*</span>
                      </label>
                      <input
                        type="text"
                        className={`${
                          errors.Code ? "is-invalid" : ""
                        } form-control`}
                        placeholder="Code"
                        name="Code"
                        value={formData?.Code}
                        onChange={handleChange}
                      />
                      {errors.Code && (
                        <div className="invalid-feedback">{errors.Code}</div>
                      )}
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">
                        Name <span className="required">*</span>
                      </label>
                      <input
                        type="text"
                        className={`${
                          errors.Name ? "is-invalid" : ""
                        } form-control`}
                        placeholder="Name"
                        name="Name"
                        value={formData?.Name}
                        onChange={handleChange}
                      />
                      {errors.Name && (
                        <div className="invalid-feedback">{errors.Name}</div>
                      )}
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Description</label>
                      <textarea
                        type="text"
                        className="form-control"
                        placeholder="Description"
                        name="Description"
                        value={formData?.Description}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <label className="form-label">Reference Code</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Reference Code"
                        name="Reference Code"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 flex-col mt-1">
              <div class="card">
                <div class="card-header">
                  <h5 className="subheading">Payroll Details</h5>
                </div>
                <div className="card-body">
                  <div className="table-responsive poc-head rounded ">
                    <button
                      type="button"
                      onClick={() => handleAddLine()}
                      className="custom-btn mb-1 pull-right text-white"
                    >
                      <i className="fa fa-plus"></i>&nbsp;Add
                    </button>
                    <Table
                      id="poctable_head"
                      className="table table-bordered"
                      bordered
                      striped
                    >
                      <thead className="text-center">
                        <tr>
                          <th>
                            <div className="d-flex justify-content-between align-items-center">
                              <span>Payroll</span>
                              <div className="dropdown">
                                <button
                                  className="btn btn-link dropdown-toggle p-0"
                                  type="button"
                                  id="payrollDropdown"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                                >
                                  <i className="bi bi-funnel-fill"></i>
                                </button>
                                <ul
                                  className="dropdown-menu p-2"
                                  aria-labelledby="payrollDropdown"
                                  style={{ zIndex: 1050, position: "absolute" }}
                                >
                                  <li>
                                    <label className="mb-1">
                                      Show items with value that:
                                    </label>
                                    <Select
                                      className="small-select mb-2"
                                      options={[{ value: "", label: "Select" }]}
                                    />
                                  </li>
                                  <li>
                                    <Select
                                      className="small-select mb-2"
                                      options={[{ value: "", label: "Select" }]}
                                    />
                                  </li>
                                  <li>
                                    <Select
                                      className="small-select mb-2"
                                      options={[{ value: "", label: "Select" }]}
                                    />
                                  </li>
                                  <li>
                                    <div className="d-flex justify-content-center">
                                      <button className="me-2 btn btn-sm btn-primary">
                                        Filter
                                      </button>
                                      <button className="btn btn-sm btn-secondary">
                                        Clear
                                      </button>
                                    </div>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </th>
                          <th>
                            <div className="d-flex justify-content-between align-items-center">
                              <span>Sequence</span>
                              <div className="dropdown">
                                <button
                                  className="btn btn-link dropdown-toggle p-0"
                                  type="button"
                                  id="sequenceDropdown"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                                >
                                  <i className="bi bi-funnel-fill"></i>
                                </button>
                                <ul
                                  className="dropdown-menu p-2"
                                  aria-labelledby="sequenceDropdown"
                                  style={{ zIndex: 1050, position: "absolute" }}
                                >
                                  <li>
                                    <label className="mb-1">
                                      Show items with value that:
                                    </label>
                                    <Select
                                      className="small-select mb-2"
                                      options={[{ value: "", label: "Select" }]}
                                    />
                                  </li>
                                  <li>
                                    <Select
                                      className="small-select mb-2"
                                      options={[{ value: "", label: "Select" }]}
                                    />
                                  </li>
                                  <li>
                                    <Select
                                      className="small-select mb-2"
                                      options={[{ value: "", label: "Select" }]}
                                    />
                                  </li>
                                  <li>
                                    <div className="d-flex justify-content-center">
                                      <button className="me-2 btn btn-sm btn-primary">
                                        Filter
                                      </button>
                                      <button className="btn btn-sm btn-secondary">
                                        Clear
                                      </button>
                                    </div>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </th>
                          <th>
                            <div className="d-flex justify-content-between align-items-center">
                              <span>From Date</span>
                              <div className="dropdown">
                                <button
                                  className="btn btn-link dropdown-toggle p-0"
                                  type="button"
                                  id="fromDateDropdown"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                                >
                                  <i className="bi bi-funnel-fill"></i>
                                </button>
                                <ul
                                  className="dropdown-menu p-2"
                                  aria-labelledby="fromDateDropdown"
                                  style={{ zIndex: 1050, position: "absolute" }}
                                >
                                  <li>
                                    <label className="mb-1">
                                      Show items with value that:
                                    </label>
                                    <Select
                                      className="small-select mb-2"
                                      options={[{ value: "", label: "Select" }]}
                                    />
                                  </li>
                                  <li>
                                    <CustomDatePicker
                                      className="small-datepicker mb-2"
                                      placeholderText="DD-MMM-YYYY"
                                    />
                                  </li>
                                  <li>
                                    <Select
                                      className="small-select mb-2"
                                      options={[{ value: "", label: "Select" }]}
                                    />
                                  </li>
                                  <li>
                                    <Select
                                      className="small-select mb-2"
                                      options={[{ value: "", label: "Select" }]}
                                    />
                                  </li>
                                  <li>
                                    <CustomDatePicker
                                      className="small-datepicker mb-2"
                                      placeholderText="DD-MMM-YYYY"
                                    />
                                  </li>
                                  <li>
                                    <div className="d-flex justify-content-center">
                                      <button className="me-2 btn btn-sm btn-primary">
                                        Filter
                                      </button>
                                      <button className="btn btn-sm btn-secondary">
                                        Clear
                                      </button>
                                    </div>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </th>
                          <th>
                            <div className="d-flex justify-content-between align-items-center">
                              <span>To Date</span>
                              <div className="dropdown">
                                <button
                                  className="btn btn-link dropdown-toggle p-0"
                                  type="button"
                                  id="toDateDropdown"
                                  data-bs-toggle="dropdown"
                                  aria-expanded="false"
                                >
                                  <i className="bi bi-funnel-fill"></i>
                                </button>
                                <ul
                                  className="dropdown-menu p-2"
                                  aria-labelledby="toDateDropdown"
                                  style={{ zIndex: 1050, position: "absolute" }}
                                >
                                  <li>
                                    <label className="mb-1">
                                      Show items with value that:
                                    </label>
                                    <Select
                                      className="small-select mb-2"
                                      options={[{ value: "", label: "Select" }]}
                                    />
                                  </li>
                                  <li>
                                    <CustomDatePicker
                                      className="small-datepicker mb-2"
                                      placeholderText="DD-MMM-YYYY"
                                    />
                                  </li>
                                  <li>
                                    <Select
                                      className="small-select mb-2"
                                      options={[{ value: "", label: "Select" }]}
                                    />
                                  </li>
                                  <li>
                                    <Select
                                      className="small-select mb-2"
                                      options={[{ value: "", label: "Select" }]}
                                    />
                                  </li>
                                  <li>
                                    <CustomDatePicker
                                      className="small-datepicker mb-2"
                                      placeholderText="DD-MMM-YYYY"
                                    />
                                  </li>
                                  <li>
                                    <div className="d-flex justify-content-center">
                                      <button className="me-2 btn btn-sm btn-primary">
                                        Filter
                                      </button>
                                      <button className="btn btn-sm btn-secondary">
                                        Clear
                                      </button>
                                    </div>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </th>
                          <th>
                            <div className="d-flex justify-content-between align-items-center">
                              <span>Delete</span>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {formData?.Slabs?.map((ele, index) => (
                          <tr key={index}>
                            <td>
                              <Select
                                menuPortalTarget={document.body}
                                styles={{
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                }}
                                options={[
                                  { value: "", label: "Select" },
                                  ...payrollOption,
                                ]}
                                placeholder="Payroll"
                                value={payrollOption?.find(
                                  (o) => o.value === ele?.PayrollID
                                )}
                                onChange={(SelectedOption, action) =>
                                  handleSlabsSelect(
                                    SelectedOption,
                                    action.name,
                                    index
                                  )
                                }
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                className="form-control text-end"
                                name="Sequence"
                                placeholder="Sequence"
                                value={ele?.Sequence}
                                onChange={(e) => handleSlabsChange(e, index)}
                              />
                            </td>
                            <td>
                              <CustomDatePicker
                                className="form-control"
                                name="FromDate"
                                placeholderText="DD-MMM-YYYY"
                                value={ele?.FromDate}
                                handleChange={(e) =>
                                  handleSlabsChange(e, index)
                                }
                              />
                            </td>
                            <td>
                              <CustomDatePicker
                                name="ToDate"
                                className="form-control"
                                placeholderText="DD-MMM-YYYY"
                                value={ele?.ToDate}
                                handleChange={(e) =>
                                  handleSlabsChange(e, index)
                                }
                              />
                            </td>
                            <td className="text-center">
                              <i
                                className="fa fa-trash-o mt-2 icon"
                                onClick={() =>
                                  handleDeleteSlabsLine(ele?.LineNo)
                                }
                              ></i>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="container">
              <div className="d-flex justify-content-end mt-2">
                <div className="d-flex">
                  <div>
                    <button
                      type="button"
                      className="cancel-btn me-2"
                      onClick={() => navigate(`/rujul/hrm/payroll-scales`)}
                    >
                      Cancel
                    </button>
                  </div>
                  <div>
                    <button type="submit" className=" custom-btn">
                      {loading ? <FaSpinner class="sm-spinner" /> : "Submit"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PayrollScalesAdd;
